import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import CancelIcon from "@mui/icons-material/Cancel";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CollectionsIcon from "@mui/icons-material/Collections";
import InventoryIcon from "@mui/icons-material/Inventory";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import CategoryIcon from "@mui/icons-material/Category";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { useNavigate } from "react-router-dom";

const AdminSidemenu = ({ menu, setMenu }) => {
  const navigate = useNavigate();
  return (
    <div className={`admin-sidemenu-container ${menu && "active"}`}>
      <div className="w-100 d-flex justify-content-end p-3">
        <CancelIcon
          onClick={() => setMenu(!menu)}
          className="text-dark cancel-icon"
        />
      </div>
      <ul>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-dashboard");
          }}
        >
          <HomeIcon className="me-2" />
          Dashboard
        </li>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-orders");
          }}
        >
          <ReceiptIcon className="me-2" />
          Orders
        </li>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-products");
          }}
        >
          <InventoryIcon className="me-2" />
          Product
        </li>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-wallet-history");
          }}
        >
          <AccountBalanceWalletIcon className="me-2" />
          Wallet History
        </li>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-users");
          }}
        >
          <GroupIcon className="me-2" />
          Customers
        </li>        
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-gallery");
          }}
        >
          <CollectionsIcon className="me-2" />
          Gallery
        </li>       
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-product-category");
          }}
        >
          <CategoryIcon className="me-2" />
          Product Category
        </li>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-banners");
          }}
        >
          <ViewCarouselIcon className="me-2" />
          Banners
        </li>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-leaderboard");
          }}
        >
          <ViewCarouselIcon className="me-2" />
          Leaderboard
        </li>
        <li
          onClick={() => {
            setMenu(!menu);
            navigate("/admin-subscription-plans");
          }}
        >
          <WorkspacePremiumIcon className="me-2" />
          Subscription Plans
        </li>
      </ul>
    </div>
  );
};

export default AdminSidemenu;
